<template>
  <div title="Swich Languages" class="custom-dropdown" @click="toggleDropdown">
    <div class="selected-option">
      <img :src="getFlagImage(currentLang)" alt="Flag" width="32" height="32">
      {{ languages[currentLang] }}
      <i class="arrow-icon" :class="{ 'arrow-down':!showDropdown, 'arrow-up': showDropdown }"></i>
    </div>
    
  </div>

  <div v-if="showDropdown" class="dropdown-options">
    <div
        v-for="(lang, i) in langs"
        :key="`Lang${i}`"
        class="dropdown-option"
        @click="changeLanguage(lang)"
    >
        <img :src="getFlagImage(lang)" alt="Flag" width="32" height="32">
        {{ languages[lang] }}
    </div>
    </div>
  
</template>

<script>
export default {
    name: 'LanguageDropdown',
  props: {
    langs: {
      type: Array,
      required: true
    },
    languages: {
      type: Object,
      required: true
    },
    flags: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentLang: 'km',
      showDropdown: false
    }
  },
  methods: {
    getFlagImage(lang) {
      return this.flags[lang];
    },
    toggleDropdown() {
      this.showDropdown =!this.showDropdown;
    },
    changeLanguage(lang) {
      this.currentLang = lang;
      this.showDropdown = false;
      this.$i18n.locale = lang; // Change the language using vue-i18n
    }
  }
}
</script>

<style scoped>
.custom-dropdown {
  position: relative;
  display: inline-block;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center; /* Center align content horizontally */
  cursor: pointer; /* Change cursor to pointer on hover */
  color:#fff;
}

.custom-dropdown:hover {
  background-color: #f5f5f5;
  color:black;
}

.selected-option {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.dropdown-options {
  position: absolute;
  top: calc(10% + 50px); /* Adjust as needed */
  right: 0;
  width: 25;
  background-color: #fff;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.dropdown-option {
  padding: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.dropdown-option:hover {
  background-color: #f5f5f5;
}

.arrow-icon {
  margin-left: 5px;
  transition: transform 0.3s ease;
}

.arrow-up {
  transform: rotate(180deg);
}
</style>